import { parseUrl, trackEvent, isBrowser, getBaseUrl } from 'utils';

/**
 * Function: trackLinkOut
 * Description: Tracks when a user clicks on an external link.
 * Parameters:
 *   - link: The URL of the external link being clicked.
 * Behavior:
 *   - Checks if the environment is a browser and if the link parameter is valid.
 *   - Parses the current window's origin to extract hostname and pathname.
 *   - Sends a tracking event with the event name 'Link-Out', the link clicked,
 *     and the concatenated hostname and pathname for context.
 */
export const trackLinkOut = (link: string) => {
  if (!isBrowser() || !link) return;

  const parsedUrl = parseUrl(getBaseUrl());
  const hostname = parsedUrl?.hostname || '';
  const pathname = parsedUrl?.pathname || '';

  trackEvent('Link-Out', link, hostname + pathname);
};
